module.exports = __webpack_public_path__ + "media/images/favicon-8ba51fc86b99e63e865dacee82f45fc5.jpg";